import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-38454652"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-menu" }
const _hoisted_2 = {
  class: "list-items",
  role: "menu"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "parent"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mid-parent" }
const _hoisted_8 = { class: "childs visible" }
const _hoisted_9 = { class: "bottom-menu" }
const _hoisted_10 = {
  class: "list-items",
  role: "menu"
}
const _hoisted_11 = { class: "main-route" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-question-circle" }, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "main-route" }
const _hoisted_15 = { key: 0 }

import { ref, onMounted, watch } from "vue";

import { useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { extractBeforeColon } from "@/services/utils/Strings";
import { useSidebarStore } from "@/store/sidebar/sidebar";
import { rootGetters } from "@/main";
import { useOwnWorkbooksStore } from "@/store/catalog_data/dashboards";
import { Workbook } from "@/store/analytics/dasboards";

interface ParentRoute {
  name: string;
  title: string;
  icon?: string;
  path: string;
  active: boolean;
  expanded?: boolean;
  scope?: string;
  children?: ParentRoute[];
  external?: boolean;
  inhouse?: boolean;
  hidden?: boolean;
  to?: string | object;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LeftMenuSidebar',
  setup(__props) {

const route = useRoute();
const authStore = useAuthStore();
const filteredRoutes = ref<ParentRoute[]>([]);
const sidebarStore = useSidebarStore();
const workbooksStore = useOwnWorkbooksStore();

const onSideBarClick = () => {
  sidebarStore.switchState();
};

const onParentRouteClick = () => {
  sidebarStore.openSidebar();
};

onMounted(async () => {
  await filterRoutes();
  setActiveRoute(filteredRoutes.value);
});

watch(
  () => route.fullPath,
  () => {
    setActiveRoute(filteredRoutes.value);
  }
);

const filterRoutes = async () => {
  if (!authStore.user && authStore.isLoggedIn) {
    await authStore.getUserInfo();
  }

  const isDemoUser = Boolean(
    authStore.user?.role?.department?.organization?.is_demo
  );

  filteredRoutes.value = JSON.parse(JSON.stringify(buildRoutes(isDemoUser)));

  const payload = authStore.getPayload();
  if (payload && payload.scopes) {
    const permissions = payload.scopes
      .map(extractBeforeColon)
      .concat(payload.scopes);
    if (permissions.includes("system") || payload.user.is_superuser) return;
    filteredRoutes.value = filterRoutesByScopes(
      filteredRoutes.value,
      permissions
    );
  }

  if (isDemoUser) {
    await attachDemoWorkbookRoutes();
  }
  return [];
};

const attachDemoWorkbookRoutes = async () => {
  await workbooksStore.getItems("", [], true, false, 0, 50, true);

  const analyticsRoute = filteredRoutes.value.find(
    (routeItem) => routeItem.path === "/analytics"
  );
  if (!analyticsRoute?.children) return;

  const demoWorkbookRoutes: ParentRoute[] = workbooksStore.itemList
    .filter((item: Workbook) => item.dashboards && item.dashboards.length > 0)
    .map((item: Workbook) => ({
      name: `demo-dashboard-${item.id}`,
      title: item.dashboards[0]?.name || item.name,
      active: false,
      path: `/analytics/demo/${item.id}`,
      scope: "analytics",
      to: {
        name: "demoDashboards",
        params: { workbookId: item.id },
      },
    }));

  analyticsRoute.children = analyticsRoute.children.concat(demoWorkbookRoutes);
};

function filterRoutesByScopes(
  routes: ParentRoute[],
  scopes: string[]
): ParentRoute[] {
  return routes
    .filter((route) => !route.hidden)
    .filter((route) => !route.scope || scopes.includes(route.scope))
    .filter((route) => !route.external || scopes.includes("external_agency"))
    .filter((route) => {
      if (route.inhouse) {
        const isInhouseUser =
          authStore.getPayloadTenant() === rootGetters.inhouse_tenant;
        return isInhouseUser;
      }
      return true;
    })
    .map((route) => {
      if (route.children) {
        const filteredChildren = filterRoutesByScopes(route.children, scopes);
        return { ...route, children: filteredChildren };
      }
      return route;
    });
}

const setActiveRoute = (routes: any) => {
  const markActiveRoutes = (routeList: ParentRoute[]) => {
    routeList.forEach((routeInSidebar: ParentRoute) => {
      const active = route.fullPath.includes(routeInSidebar.path);
      routeInSidebar.active = active;

      if (routeInSidebar.children) {
        routeInSidebar.expanded = active;
        markActiveRoutes(routeInSidebar.children);
      }
    });
  };

  markActiveRoutes(routes);
};

const buildRoutes = (isDemo = false): ParentRoute[] => [
  {
    name: "listSegments",
    title: "Сегменты",
    icon: "pi-database",
    active: false,
    path: "/segments",
    scope: "segment",
  },
  {
    name: "listCampaigns",
    title: "Кампании",
    icon: "pi-briefcase",
    active: false,
    path: "/campaigns",
    scope: "campaign",
  },
  {
    name: "settings",
    title: "Настройки",
    icon: "pi-cog",
    active: false,
    path: "/settings",
    scope: "settings",
  },
  {
    name: "",
    title: "Справочники",
    icon: "pi-book",
    active: false,
    expanded: false,
    path: "/dictionaries",
    scope: "dictionaries",
    children: [
      {
        name: "listOrganizations",
        title: "Организации",
        active: false,
        path: "/organizations",
        scope: "organization",
      },
      {
        name: "users",
        title: "Пользователи",
        active: false,
        path: "/users",
        scope: "users",
      },
      {
        name: "brands",
        title: "Бренды",
        active: false,
        path: "/brands",
      },
      {
        name: "shops",
        title: "Магазины",
        active: false,
        path: "/shops",
      },
      {
        name: "adsCabinets",
        title: "Рекламные кабинеты",
        active: false,
        path: "/ads-cabinets",
      },
      {
        name: "platforms",
        title: "Рекламные площадки",
        active: false,
        path: "/platforms",
      },
      {
        name: "estimationParams",
        title: "Параметры эстимации",
        active: false,
        path: "/estimation-params",
        scope: "analytics:edit",
      },
      {
        name: "workbooks",
        title: "Воркбуки",
        active: false,
        path: "/workbooks",
        scope: "analytics",
      },
    ],
  },
  {
    name: "",
    title: "Аналитика",
    icon: "pi-chart-line",
    active: false,
    expanded: false,
    path: "/analytics",
    scope: "analytics",
    children: [
      {
        name: "",
        title: "Кастомизация",
        active: false,
        path: "",
        scope: "analytics:edit",
        children: [
          {
            name: "traficPlanList",
            title: "План трафика",
            active: false,
            path: "/trafic-plan",
            scope: "analytics:edit",
          },
          {
            name: "estimationSettings",
            title: "Эстимация",
            active: false,
            path: "/estimation-settings",
            scope: "analytics:edit",
          },
        ],
      },
      {
        name: "dashboards",
        title: "Дашборды",
        active: false,
        path: "/dashboards",
        scope: "analytics",
        hidden: isDemo,
      },
      {
        name: "clientDashboards",
        title: "Клиентские отчёты",
        active: false,
        path: "/client-dashboards",
        scope: "analytics",
        external: true,
        hidden: isDemo,
      },
      {
        name: "preSale",
        title: "Pre-sale",
        active: false,
        path: "/pre-sale",
        scope: "analytics",
        inhouse: true,
        hidden: isDemo,
      },
    ],
  },
  {
    name: "",
    title: "Расходы",
    icon: "pi-wallet",
    active: false,
    expanded: false,
    path: "/expenses",
    scope: "expenses",
    children: [
      {
        name: "expensesStatistics",
        title: "Статистика",
        active: false,
        path: "/expenses/statistics",
        scope: "expenses",
      },
      {
        name: "coefficients",
        title: "Коэффициенты",
        active: false,
        path: "/coefficients",
        scope: "expenses:edit",
      },
    ],
  },
];


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'left-sidebar',
      _unref(sidebarStore).isOpen ? 'left-sidebar--open' : 'left-sidebar--close',
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRoutes.value, (route) => {
          return (_openBlock(), _createElementBlock("li", {
            key: route.name,
            class: "main-route"
          }, [
            (!('children' in route))
              ? _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  to: { name: route.name },
                  class: _normalizeClass([route.active ? 'active' : ''])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(['pi', route.icon])
                    }, null, 2),
                    (_unref(sidebarStore).isOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(route.title), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to", "class"])), [
                  [
                    _directive_tooltip,
                    _unref(sidebarStore).isOpen ? '' : route.title,
                    void 0,
                    { right: true }
                  ]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["name", [route.active ? 'active' : '']]),
                    onClick: ($event: any) => {
                route.expanded = _unref(sidebarStore).isOpen ? !route.expanded : true;
                onParentRouteClick();
              }
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(['pi', route.icon])
                    }, null, 2),
                    (_unref(sidebarStore).isOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(route.title), 1))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_5)), [
                    [
                      _directive_tooltip,
                      _unref(sidebarStore).isOpen ? '' : route.title,
                      void 0,
                      { right: true }
                    ]
                  ]),
                  (_unref(sidebarStore).isOpen)
                    ? (_openBlock(), _createElementBlock("ul", {
                        key: 0,
                        class: _normalizeClass(["childs", route.expanded ? 'visible' : 'hidden'])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.children, (child) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: child.name
                          }, [
                            (child.name.length)
                              ? (_openBlock(), _createBlock(_component_RouterLink, {
                                  key: 0,
                                  to: child.to || { name: child.name },
                                  class: _normalizeClass([child.active ? 'active' : ''])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, _toDisplayString(child.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "class"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(child.title), 1),
                                  _createElementVNode("ul", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (childThird) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: childThird.name
                                      }, [
                                        _createVNode(_component_RouterLink, {
                                          to: childThird.to || { name: childThird.name },
                                          class: _normalizeClass([childThird.active ? 'active' : ''])
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, _toDisplayString(childThird.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to", "class"])
                                      ]))
                                    }), 128))
                                  ])
                                ], 64))
                          ]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true)
                ]))
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("ul", _hoisted_10, [
        _createElementVNode("li", _hoisted_11, [
          _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
            to: "/training",
            class: _normalizeClass([_unref(route).name === 'training' ? 'active' : ''])
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              (_unref(sidebarStore).isOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Обучение"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])), [
            [
              _directive_tooltip,
              _unref(sidebarStore).isOpen ? '' : 'Обучение',
              void 0,
              { right: true }
            ]
          ])
        ]),
        _createElementVNode("li", _hoisted_14, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: onSideBarClick,
            class: "hide-menu-button"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass([
                'pi',
                _unref(sidebarStore).isOpen ? 'pi-angle-left' : 'pi-angle-right',
              ])
            }, null, 2),
            (_unref(sidebarStore).isOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Скрыть меню"))
              : _createCommentVNode("", true)
          ])), [
            [
              _directive_tooltip,
              _unref(sidebarStore).isOpen ? '' : 'Раскрыть меню',
              void 0,
              { right: true }
            ]
          ])
        ])
      ])
    ])
  ], 2))
}
}

})